import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { buildUrl, prepareResponseFailure } from '../../helpers';
import { apiCall } from '../../services';

const ENDPOINT = `${APIConfiguration.workflow}salesForce/worktype`;

export interface GetWorkTypeBySellerQueryPayload {
  sellerId: string;
  fileId?: string;
}

export type GetWorkTypeBySellerQueryResponse = { id: string; label: string }[];

export type GetWorkTypeBySellerQuery = (
  payload: GetWorkTypeBySellerQueryPayload,
) => Promise<
  BackResponse<GetWorkTypeBySellerQueryResponse> | BackResponseFailure
>;

const getWorkTypeBySellerQuery: GetWorkTypeBySellerQuery = async ({
  sellerId,
  fileId,
}) => {
  try {
    return await apiCall<BackResponse<GetWorkTypeBySellerQueryResponse>>(
      buildUrl(ENDPOINT, { sellerId, fileId }),
      {
        method: SUPPORTED_METHODS.GET,
      },
    );
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};

export default getWorkTypeBySellerQuery;
